/**
 * A record with only `keys` from `source` — for `useShallow` store reads, so a
 * component re-renders when one of ITS entries changes rather than on every
 * write to a store-wide map (presence, voice rooms, unread counters).
 */
export function pickKeys<V>(source: Record<string, V>, keys: readonly string[]): Record<string, V | undefined> {
  const out: Record<string, V | undefined> = {};
  for (const key of keys) out[key] = source[key];
  return out;
}
